import { adaptAM } from 'customers/tenants-detailed-view/lib/components/availabilityMachines/adaptAvailabilityMachineResponse';

export const adaptAvailabilityMachineResponse = (response) => {
  return response?.response ? adaptAM?.(response?.response?.[0]) : {};
};
